import React from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TimeLineColumn from './TimelineColumn';
import MoveTimelineButton from './MoveTimelineButton';

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: ({ rowSize }: any) => {
      return `0fr repeat(${rowSize}, [col] 2fr) 0fr`;
    },
    gridTemplateRows: ({ numOfLinesToShow }: any) => {
      if (!numOfLinesToShow) return null;
      return `repeat(${numOfLinesToShow}, [row] 0fr)`;
    },
    gridRowGap: theme.spacing(3),
  },
}));

export default function Grid(props) {
  const { rowSize = 12, numOfLinesToShow = 0 } = props;
  const { timelineInfo } = useLinesContext();
  const classes = useStyles({ rowSize, numOfLinesToShow });

  const timelineMonths = timelineInfo.months?.map((header, i) => (
    <TimeLineColumn
      column={i + 2}
      key={i}
      numOfLinesToShow={numOfLinesToShow}
      header={header}
    />
  ));

  return (
    <div className={classes.container}>
      <MoveTimelineButton moveForward={false} />
      {timelineMonths}
      <MoveTimelineButton moveForward={true} />
      {props.children}
    </div>
  );
}
